<template>
  <div class="index-wrap">
    <back-button />
    <div class="index-header">
      <div class="user-info">
        <div class="avatar">
          <img
            v-if="user"
            :src="user.avatar || require('@/assets/default-avatar.png')"
            alt="头像"
          />
        </div>
        <div v-if="user" class="nick-name">{{ user.nickname }}</div>
      </div>
    </div>
    <!-- <div class="week-info" @click="$router.push('/week')">周奖榜单</div> -->
    <!-- <div class="index-logo">
        <img :src="require('@/assets/img/top-icon.png')" />
      </div> -->
    <div class="index-label">
      <img :src="require('@/assets/img/label-icon.png')" />
    </div>
    <div class="menu-wrap">
      <van-row type="flex" justify="space-between">
        <van-col>
          <div
            class="menu-item print-1"
            @click="$router.push('/credential/list')"
          ></div>
        </van-col>
        <van-col>
          <div
            class="menu-item print-4"
            @click="$router.push('/errors?type=1')"
          ></div>
        </van-col>
        <van-col>
          <div class="menu-item print-2" @click="$router.push('/result')"></div>
        </van-col>
      </van-row>
      <van-row type="flex" justify="space-between">
        <van-col>
          <div class="menu-item print-3" @click="$router.push('/rank')"></div>
        </van-col>
        <van-col>
          <div class="menu-item print-5" @click="$router.push('/reward')"></div>
        </van-col>
        <van-col>
          <div class="menu-item print-6" @click="$router.push('/week')"></div>
        </van-col>
      </van-row>
    </div>
    <!-- <div class="bottom-label">
        <img :src="require('@/assets/img/bottom-label.png')"/>
      </div> -->
  </div>
</template>
<script>
import BackButton from "@/components/BackButton.vue";
export default {
  components: {
    BackButton,
  },
  computed: {
    user() {
      return this.$store.state.user;
    },
  },
};
</script>
<style lang="scss" scoped>
.index-wrap {
  position: relative;
  @include index-bg;
  .index-label {
    margin-top: 80px;
    text-align: center;

    img {
      width: 344px;
      vertical-align: top;
    }
  }

  .index-header {
    position: absolute;
    top: 30px;
    .user-info {
      display: flex;
      align-items: center;
      max-width: 120px;
      padding: 5px 22px;
      background: rgba(145, 55, 249, 0.7);
      border-radius: 0 24px 24px 0;

      .avatar {
        flex-shrink: 0;
        width: 39px;
        height: 39px;
        margin-right: 10px;
        overflow: hidden;
        vertical-align: top;
        border-radius: 50%;

        img {
          width: 100%;
          vertical-align: top;
        }
      }

      .nick-name {
        max-width: 100px;
        max-height: 35px;
        font-size: 14px;
        line-height: 35px;
        color: #fff;
        @include textoverflow(1);
      }
    }
  }

  .menu-wrap {
    z-index: 100;
    padding: 30px 17px 0;

    .menu-item {
      width: 104px;
      height: 53px;
      margin-bottom: 19px;
      cursor: pointer;
    }

    @for $i from 1 through 6 {
      .print-#{$i} {
        background: url("~@/assets/img/print-#{$i}.png")
          no-repeat
          top
          center/100%;
      }
    }
  }
  // .bottom-label{
  //   position: absolute;
  //   bottom: 0;
  //   left: 0;
  //   z-index: 1;
  //   img{
  //     width: 100%;
  //     vertical-align: top;
  //   }
  // }
}
</style>
